import React, { useState } from "react";
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggestOutlined';
import WarningIcon from '@mui/icons-material/WarningAmberOutlined';
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';

/**
 * IdlePermissionBanner
 * Show this component inside TemplateCore.
 * It appears only when idle-detection permission is not yet granted.
 * The Allow button triggers requestPermission() on user click — required by Chrome.
 */
function IdlePermissionBanner({ showBanner, permissionState, isSupported, requestPermission }) {
  const [loading, setLoading] = useState(false);

  // Don't show if: already granted, not supported, or banner flag is false
  if (!showBanner || !isSupported || permissionState === "granted") return null;

  const handleAllow = async () => {
    setLoading(true);
    await requestPermission();
    setLoading(false);
  };

  if (permissionState === "denied") {
    return (
      <div style={styles.banner("#7f1d1d", "#fca5a5")}>
        <span>
          <WarningIcon/> WFH activity tracking permission was <strong>denied</strong>.
          To re-enable: Chrome address bar → <DisplaySettingsIcon/> icon → Site Settings → Your Device Use → Allow
        </span>
      </div>
    );
  }

  return (
    <div style={styles.banner("#1e3a5f", "#bfdbfe")}>
      <span style={{ fontSize: 13 }}>
        <SettingsSuggestIcon/> <strong>HRMS</strong> needs permission to track your WFH activity.
      </span>
      <button
        onClick={handleAllow}
        disabled={loading}
        style={styles.button(loading)}
      >
        {loading ? "Requesting..." : "Allow Tracking"}
      </button>
    </div>
  );
}

const styles = {
  banner: (bg, color) => ({
    position:       "fixed",
    top:            0,
    left:           0,
    right:          0,
    zIndex:         99999,
    display:        "flex",
    alignItems:     "center",
    justifyContent: "space-between",
    gap:            12,
    padding:        "10px 20px",
    background:     bg,
    color:          color,
    borderBottom:   `2px solid ${color}`,
    fontSize:       13,
    fontFamily:     "inherit",
  }),
  button: (loading) => ({
    padding:       "7px 20px",
    borderRadius:  6,
    border:        "none",
    background:    "#2563eb",
    color:         "white",
    fontSize:      13,
    fontWeight:    600,
    cursor:        loading ? "not-allowed" : "pointer",
    whiteSpace:    "nowrap",
    opacity:       loading ? 0.7 : 1,
    flexShrink:    0,
  }),
};

export default IdlePermissionBanner;